import React from "react";
import { IUser } from "core/types/base/IUser";
import Svg from "components/common/SVG/Svg";
import TenantAdminsTable from "components/tenants/TenantAdminsTable";

interface AdminsTabProps {
  users: IUser[];
  onSort: (key: string) => void;
  onAddAdmin: () => void;
  handleDropdownAction: (
    row: IUser,
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    actionKey: string,
  ) => void;
}

const AdminsTab: React.FC<AdminsTabProps> = ({
  users,
  onSort,
  onAddAdmin,
  handleDropdownAction,
}) => (
  <div className="card shadow-lg">
    <div className="card-body">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5>Tenant Admins</h5>
        <button
          type="button"
          title="Create Admin"
          className="btn btn-sm btn-success"
          onClick={onAddAdmin}
        >
          <Svg icon="create" width={15} height={15} color="#ffffff" />
          <span className="ms-2">Create</span>
        </button>
      </div>
      <TenantAdminsTable
        users={users}
        onSort={onSort}
        handleDropdownAction={handleDropdownAction}
      />
    </div>
  </div>
);

export default AdminsTab;
